// extracted by mini-css-extract-plugin
export default {"container":"cart-page_container__DtKQj"};